import { Offcanvas } from 'bootstrap';

// De oude popup-API blijft bestaan zodat bestaande call sites (data-toggle-popup,
// window.showPopup) ongewijzigd werken; de uitvoering is nu een Bootstrap offcanvas.
function instance(popupId) {
    const element = document.getElementById(popupId);

    return element ? Offcanvas.getOrCreateInstance(element) : null;
}

window.showPopup = function (popupId) {
    instance(popupId)?.show();
};

window.hidePopup = function (popupId) {
    instance(popupId)?.hide();
};

document.addEventListener('click', function (event) {
    const toggleButton = event.target.closest('[data-toggle-popup]');

    if (toggleButton) {
        window.showPopup(toggleButton.getAttribute('data-id'));
        return;
    }

    const closeButton = event.target.closest('[data-close-popup]');

    if (closeButton) {
        window.hidePopup(closeButton.getAttribute('data-id'));
    }
});

// TinyMCE rendert menu's en dialogs buiten de drawer; zonder dit trekt de
// focus trap van het offcanvas de focus meteen terug.
document.addEventListener('focusin', function (event) {
    if (event.target.closest?.('.tox-tinymce-aux, .tox-dialog, .tox-menu, .tox-pop, .tox-collection')) {
        event.stopImmediatePropagation();
    }
});
